import { render, staticRenderFns } from "./PdpProductDetails.vue?vue&type=template&id=4d0f2c8a&scoped=true&"
import script from "./PdpProductDetails.vue?vue&type=script&lang=js&"
export * from "./PdpProductDetails.vue?vue&type=script&lang=js&"
import style0 from "./PdpProductDetails.vue?vue&type=style&index=0&id=4d0f2c8a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0f2c8a",
  null
  
)

export default component.exports